// DS: i7.27
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const EditorAnchor: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M12 4a3.155 3.155 0 00-1.014 6.143v7.829c0 .049.004.097.011.144a6.202 6.202 0 01-5.13-5.215h.724a.901.901 0 000-1.802h-1.69A.901.901 0 004 12a8 8 0 1016 0v-.015a.901.901 0 00-.902-.887l-1.69.001a.901.901 0 100 1.803h.724a6.2 6.2 0 01-5.361 5.248.909.909 0 00.018-.178V10.21A3.156 3.156 0 0012 4zm-1.352 3.155a1.352 1.352 0 112.704 0 1.352 1.352 0 01-2.704 0z"></path>
      </svg>
    </IconWrap>
  );
};
EditorAnchor.displayName = 'EditorAnchor';

export default EditorAnchor;
